"use strict";

/**
 * IMPORTANT
 *
 * This validator file is used in the client and server-side, so it must keep only pure JS.
 * No jQuery nor SFCC references should be added here;
 */

import { CUSTOMER_DOCUMENT } from "../constants";

function isValidCpf(documentNumber) {
    documentNumber = documentNumber.replace(/[^\d]+/g, "");

    if (documentNumber == "") {
        return false;
    }

    // Eliminates known invalid CPFs;
    if (documentNumber.length != 11 ||
        documentNumber == "00000000000" ||
        documentNumber == "11111111111" ||
        documentNumber == "22222222222" ||
        documentNumber == "33333333333" ||
        documentNumber == "44444444444" ||
        documentNumber == "55555555555" ||
        documentNumber == "66666666666" ||
        documentNumber == "77777777777" ||
        documentNumber == "88888888888" ||
        documentNumber == "99999999999"
    ) {
        return false;
    }

    // Validates first digit;
    var add = 0;

    for (var i = 0; i < 9; i++) {
        add += Number(documentNumber.charAt(i)) * (10 - i);
    }

    var rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }

    if (rev != Number(documentNumber.charAt(9)))
        return false;

    // Validates second digit
    add = 0;

    for (var j = 0; j < 10; j++) {
        add += Number(documentNumber.charAt(j)) * (11 - j);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }

    if (rev != Number(documentNumber.charAt(10))) {
        return false;
    }

    return true;
}

function isValidCNPJ(cnpj) {
    if (!cnpj) {
        return false;
    }

    cnpj = cnpj.replace(/[.\-\/]/g, "").toUpperCase();

    if (cnpj == "") return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    var charValue = function (ch) { return ch.charCodeAt(0) - 48; };

    // Valida DVs
    var size    = cnpj.length - 2;
    var numbers = cnpj.substring(0, size);
    var digits  = cnpj.substring(size);
    var soma    = 0;
    var pos     = size - 7;

    for (var i = size; i >= 1; i--) {
        soma += charValue(numbers.charAt(size - i)) * pos--;
        if (pos < 2)
            pos = 9;
    }

    var result = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (result != digits.charAt(0))
        return false;

    size    = size + 1;
    numbers = cnpj.substring(0, size);
    soma    = 0;
    pos     = size - 7;

    for (i = size; i >= 1; i--) {
        soma += charValue(numbers.charAt(size - i)) * pos--;
        if (pos < 2)
            pos = 9;
    }

    result = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (result != digits.charAt(1))
        return false;

    return true;
}

export const isValidDocumentNumber = (documentNumber, documentType) => {
    if (documentType == CUSTOMER_DOCUMENT.CNPJ) {
        return isValidCNPJ(documentNumber);
    } else if (documentType == CUSTOMER_DOCUMENT.CPF) {
        return isValidCpf(documentNumber);
    }

    return false;
};
